<div class="d-flex gap-3">
  <base-button
    color="dark"
    icon="fa-solid fa-eye"
    stateClass="pe-1"
    [size]="buttonSize.md"
    [iconSize]="buttonSize.md"
    [ngbTooltip]="'externalEmployees.masterData.employeeIdCard.showCard' | translate"
    (btnClick)="downloadIDCard(true)"
  ></base-button>
  <base-button
    color="dark"
    icon="fa-solid fa-arrows-rotate"
    stateClass="pe-1"
    [size]="buttonSize.md"
    [iconSize]="buttonSize.md"
    [ngbTooltip]="'externalEmployees.masterData.employeeIdCard.regenerateCard' | translate"
    (btnClick)="openRegenerateIDModal()"
  ></base-button>
  <base-button
    color="dark"
    icon="fa-solid fa-download"
    stateClass="pe-1"
    [size]="buttonSize.md"
    [iconSize]="buttonSize.md"
    [ngbTooltip]="'externalEmployees.masterData.employeeIdCard.downloadCard' | translate"
    (btnClick)="downloadIDCard(false, true)"
  ></base-button>
</div>

<ng-template #idCardViewerTemplate>
  <base-document-viewer
    [title]="'externalEmployees.masterData.employeeIdCard.title' | translate"
    [src]="idCardActiveDocumentSrc"
    [fileName]="idCardFileName"
    [fileType]="baseFileExtension.pdf"
    [modalRef]="idCardModalRef"
    [hideBorder]="true"
    height="400px"
    (downloadImage)="downloadIDCard()"
  ></base-document-viewer>
</ng-template>
